import { render, staticRenderFns } from "./UpdatePost.vue?vue&type=template&id=07990b46&scoped=true&"
import script from "./UpdatePost.vue?vue&type=script&lang=js&"
export * from "./UpdatePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07990b46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07990b46')) {
      api.createRecord('07990b46', component.options)
    } else {
      api.reload('07990b46', component.options)
    }
    module.hot.accept("./UpdatePost.vue?vue&type=template&id=07990b46&scoped=true&", function () {
      api.rerender('07990b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Post/UpdatePost.vue"
export default component.exports